"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnhancedDropdownLayout = exports.Styled = void 0;
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const window_or_global_1 = __importDefault(require("window-or-global"));
exports.Styled = styled_components_1.default.div `
	/* Useful for local debugging. Uncomment and toss a :hover in dev tools to force open the menu
    &:hover {
        visibility: visible;
        > section {
            opacity: 1;
        }
    }
    */

	text-align: left;
	position: absolute;
	left: 0;
	width: calc(100vw - 128px);
	margin-left: 64px;
	visibility: ${(p) => (p.menuOpen ? "visible" : "hidden")};
	display: flex;
	justify-content: flex-start;
	align-items: stretch;
	background: ${(p) => p.theme.palette.background.paper};
	box-shadow: ${(p) => (p.thin ? "none" : "0px 4px 10px rgba(0, 0, 0, 0.25)")};

	> section {
		opacity: ${(p) => (p.menuOpen ? 1 : 0)};
		transition: opacity 0.5s ${(p) => p.theme.easing};
	}
	.describe {
		width: 360px;
		margin: ${(p) => (p.thin ? "36px 0 36px 48px" : "64px 0 64px 96px")};
	}
	.main-links {
		margin: 0;
		width: 430px;
		padding: ${(p) => (p.thin ? "36px 40px" : "64px 80px")};
	}
	.external {
		width: 251px;
		margin: ${(p) => (p.thin ? "36px 48px 36px 40px" : "64px 96px 64px 80px")};
	}

	a {
		padding: 10px 0;
		transition: 0.2s color ${(p) => p.theme.easing};
	}
	p {
		text-transform: none;
	}
	&& {
		a:hover {
			color: ${(p) => p.theme.palette.accent.text};
			text-decoration: none;
		}
	}

	min-height: ${(p) => (p.minHeight ? `${p.minHeight}px` : "100%")};

	${(p) => p.theme.breakpoints.down("sm")} {
		max-height: calc(
			${(p) => p.innerHeight ? `${p.innerHeight - 48 - p.theme.navHeight}px` : `100vh - 48px - ${p.theme.navHeight}px`}
		);
		overflow-y: auto;
		padding-bottom: 30px;
	}

	&.tablet {
		position: relative;
	}

	${(p) => p.theme.breakpoints.down("md")} {
		position: relative;
	}
`;
const EnhancedDropdownLayout = (_a) => {
    var { children, extraClassnames } = _a, rest = __rest(_a, ["children", "extraClassnames"]);
    const [height, setHeight] = (0, react_1.useState)(0);
    (0, react_1.useEffect)(() => {
        setHeight(window_or_global_1.default.innerHeight);
    }, [setHeight]);
    return (react_1.default.createElement(exports.Styled, Object.assign({}, rest, { innerHeight: height, className: (0, classnames_1.default)("enhanced-dropdown-layout", extraClassnames) }), children));
};
exports.EnhancedDropdownLayout = EnhancedDropdownLayout;
//# sourceMappingURL=EnhancedDropdownLayout.js.map